import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	Button,
	notification,
	Select,
	DatePicker,
} from "antd";
import Layout from "../layout/Layout";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;
const { RangePicker } = DatePicker;

const extraChargeOptions = [
	{ label: "All", value: "All" },
	{ label: "Fuel Surcharge", value: "Fuel Surcharge" },
	{ label: "Time Surcharge", value: "Time Surcharge" },
	{ label: "Light Surcharge", value: "Light Surcharge" },
	{ label: "Ice Surcharge", value: "Ice Surcharge" },
	{
		label: "Ready Mix Truck Rental Service",
		value: "Ready Mix Truck Rental Service",
	},
	{ label: "Ready Mix Driver", value: "Ready Mix Driver" },
	{ label: "Plant Stand By", value: "Plant Stand By" },
	{
		label: "Environmental Charge Per Load",
		value: "Environmental Charge Per Load",
	},
	{ label: "Shipping", value: "Shipping" },
];

const ProfitabilityReport2 = () => {
	const [loading, setLoading] = useState(true);
	const [loadingData, setLoadingData] = useState(false);
	const [loadingDataWaste, setLoadingDataWaste] = useState(false);
	const [loadingExtra, setLoadingExtra] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [plant, setPlant] = useState(undefined);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [totals, setTotals] = useState({});
	const [extras, setExtras] = useState([]);
	const [extrasData, setExtrasData] = useState([]);
	const [extrasTotals, setExtrasTotals] = useState(0);
	const [extraCharge, setExtraCharge] = useState("All");
	const [listWaste, setListWaste] = useState([]);
	const [totalsWaste, setTotalsWaste] = useState(0);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "JAP",
			children: [
				{
					title: "Sold Price",
					dataIndex: "totalSoldPriceJAP",
					key: "totalSoldPriceJAP",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "Cogs",
			dataIndex: "totalCogsJAP",
			key: "totalCogsJAP",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "JAP",
			children: [
				{
					title: "Gross Profit",
					dataIndex: "totalGrossProfitJAP",
					key: "totalGrossProfitJAP",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "QB INVOICED",
			dataIndex: "qbInvoicedAvg",
			key: "qbInvoicedAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Cogs",
			dataIndex: "totalCogsJAP",
			key: "totalCogsJAP",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "QB Price",
			dataIndex: "qbPriceAvg",
			key: "qbPriceAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "QB",
			children: [
				{
					title: "Gross Profit",
					dataIndex: "grossProfitAvg",
					key: "grossProfitAvg",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
	];

	const columns2 = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Clients",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Sold Price",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "COGS",
			dataIndex: "cogs",
			key: "cogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "GROSS PROFIT",
			dataIndex: "grossProfitJAP",
			key: "grossProfitJAP",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "QB INVOICED",
			dataIndex: "qbInvoiced",
			key: "qbInvoiced",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "COGS",
			dataIndex: "cogs",
			key: "cogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "QB PRICE",
			dataIndex: "qbPrice",
			key: "qbPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "GROSS PROFIT",
			dataIndex: "grossProfit",
			key: "missionGross",
			render: (value) => {
				if (value < 0) {
					return <Text>-</Text>;
				}

				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						prefix={"$"}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
	];

	const columns3 = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Extra Charges & Fees",
			dataIndex: "extraText",
			key: "extraText",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total $",
			dataIndex: "total",
			key: "total",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columnsWaste = [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Cogs",
			dataIndex: "totalCogsJAP",
			key: "totalCogsJAP",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columns2Waste = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Clients",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "COGS",
			dataIndex: "cogs",
			key: "cogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const summaryExtras = (pageData) => {
		let total = 0;

		pageData.forEach((item) => {
			total += item.total;
		});

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={3} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={total}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		);
	};
	const summaryParent = (pageData) => {
		let totalYardsTotal = 0;
		let totalUnitPriceTotal = 0;
		let totalSoldPriceJAPTotal = 0;
		let totalCogsJAPTotal = 0;
		let totalGrossProfitTotal = 0;
		let qbInvoicedAvgTotal = 0;
		let totalqbPriceTotal = 0;
		let totalqbProfitTotal = 0;

		pageData.forEach((item) => {
			totalYardsTotal += item.totalYards;
			totalUnitPriceTotal += item.totalUnitPrice;
			totalCogsJAPTotal += item.totalYards * item.totalCogsJAP;
			totalGrossProfitTotal += item.totalYards * item.totalGrossProfitJAP;
			totalqbProfitTotal += item.totalYards * item.grossProfitAvg;
			qbInvoicedAvgTotal += item.qbInvoicedAvg;
		});

		totalSoldPriceJAPTotal =
			totalYardsTotal === 0 ? 0 : totalUnitPriceTotal / totalYardsTotal;

		totalCogsJAPTotal =
			totalYardsTotal === 0 ? 0 : totalCogsJAPTotal / totalYardsTotal;
		totalGrossProfitTotal =
			totalYardsTotal === 0 ? 0 : totalGrossProfitTotal / totalYardsTotal;
		totalqbPriceTotal =
			totalYardsTotal === 0 ? 0 : qbInvoicedAvgTotal / totalYardsTotal;
		totalqbProfitTotal =
			totalYardsTotal === 0 ? 0 : totalqbProfitTotal / totalYardsTotal;

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={2} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalYardsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalUnitPriceTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalSoldPriceJAPTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalCogsJAPTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalGrossProfitTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={qbInvoicedAvgTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalCogsJAPTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalqbPriceTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalqbProfitTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		);
	};
	const summaryWaste = (pageData) => {
		let totalYardsTotal = 0;
		let totalCogsJAPTotal = 0;

		pageData.forEach((item) => {
			totalYardsTotal += item.totalYards;
			totalCogsJAPTotal += item.totalYards * item.totalCogsJAP;
		});

		totalCogsJAPTotal =
			totalYardsTotal === 0 ? 0 : totalCogsJAPTotal / totalYardsTotal;

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={2} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalYardsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalCogsJAPTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		);
	};

	const expandedRowRender = (row) => {
		const summaryChild = (pageData) => {
			let totalYardsTotal = 0;
			let totalUnitPriceTotal = 0;
			let qbInvoicedTotal = 0;
			let cogsTotal = 0;
			let salesTotal = 0;
			let grossTotal = 0;
			let grossJAPTotal = 0;
			let salesJAPTotal = 0;

			pageData.forEach((item) => {
				totalYardsTotal += item.totalYards;
				totalUnitPriceTotal += item.totalUnitPrice;
				qbInvoicedTotal += item.qbInvoiced;
				cogsTotal += item.cogs;
				// grossTotal += item.grossProfit;
				grossTotal += item.totalYards * item.grossProfit;
				grossJAPTotal += item.totalYards * item.grossProfitJAP;
			});

			grossJAPTotal = grossJAPTotal / totalYardsTotal;
			salesJAPTotal = totalUnitPriceTotal / totalYardsTotal;

			cogsTotal = cogsTotal / pageData.length;
			salesTotal = qbInvoicedTotal / totalYardsTotal;

			grossTotal = grossTotal / totalYardsTotal;

			return (
				<>
					<Table.Summary.Row>
						<Table.Summary.Cell colSpan={4} />
						<Table.Summary.Cell>
							<Text style={{ fontSize: 14 }} strong>
								{"Total"}
							</Text>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalYardsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalUnitPriceTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={salesJAPTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={cogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={grossJAPTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={qbInvoicedTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>

						<Table.Summary.Cell>
							<Statistic
								title=""
								value={cogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>

						<Table.Summary.Cell>
							<Statistic
								title=""
								value={salesTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>

						<Table.Summary.Cell>
							<Statistic
								title=""
								value={grossTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				</>
			);
		};

		const jobs = row.jobs;

		return (
			<Table
				columns={columns2}
				dataSource={jobs}
				pagination={false}
				summary={summaryChild}
			/>
		);
	};

	const expandedRowRenderWaste = (row) => {
		const summaryChild = (pageData) => {
			let totalYardsTotal = 0;
			let cogsTotal = 0;

			pageData.forEach((item) => {
				totalYardsTotal += item.totalYards;
				cogsTotal += item.cogs;
			});

			cogsTotal = cogsTotal / pageData.length;

			return (
				<>
					<Table.Summary.Row>
						<Table.Summary.Cell colSpan={4} />
						<Table.Summary.Cell>
							<Text style={{ fontSize: 14 }} strong>
								{"Total"}
							</Text>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalYardsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={cogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				</>
			);
		};

		const jobs = row.jobs;

		return (
			<Table
				columns={columns2Waste}
				dataSource={jobs}
				pagination={false}
				summary={summaryChild}
			/>
		);
	};

	useEffect(() => {
		getPlants();
	}, []);

	useEffect(() => {
		if (plant) {
			getJobList();
			getJobListExtras();
		}
	}, [startDate, endDate, plant]);

	const getJobList = async () => {
		setLoadingData(true);
		setLoadingDataWaste(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyplant/${plant}/${"All"}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				// const groupedPsi = data.payload
				// 	.filter((i) => i.psiId !== null && i.psiId !== undefined)
				// 	.reduce((acc, item) => {
				// 		if (!acc[`${item.psiId._id}_${item.psiId.psi}`]) {
				// 			acc[`${item.psiId._id}_${item.psiId.psi}`] = [];
				// 		}
				// 		acc[`${item.psiId._id}_${item.psiId.psi}`].push(item);
				// 		return acc;
				// 	}, {});

				const jobs = data.payload.filter(
					(i) => i.psiId !== null && i.psiId !== undefined,
				);

				// Todo excepto WASTE 57
				const groupedPsi = jobs
					.filter((item) => item.customer?.name !== "WASTE 57")
					.reduce((acc, item) => {
						const key = `${item.psiId._id}_${item.psiId.psi}`;

						if (!acc[key]) {
							acc[key] = [];
						}

						acc[key].push(item);
						return acc;
					}, {});

				// Solo WASTE 57
				const groupedWaste57 = jobs
					.filter((item) => item.customer?.name === "WASTE 57")
					.reduce((acc, item) => {
						const key = `${item.psiId._id}_${item.psiId.psi}`;

						if (!acc[key]) {
							acc[key] = [];
						}

						acc[key].push(item);
						return acc;
					}, {});

				console.log("groupedPsi", groupedPsi);
				console.log("groupedWaste57", groupedWaste57);

				const newRows = Object.entries(groupedPsi).map(([key, jobs]) => {
					const fistRow = jobs[0];
					const [psiId, psiName] = key.split("_");

					const totalUnitPrice = jobs.reduce(
						(accum, r) => accum + r.loadYD3 * r.unitPrice,
						0,
					);

					const totalYards = jobs.reduce((accum, r) => accum + r.loadYD3, 0);

					const totalCogsJAP = jobs.reduce(
						(accum, r) =>
							accum + r.aggregate ? getAggregateCogsCost(r.aggregate) : 0,
						0,
					);

					const totalSoldPriceJAP = totalUnitPrice / totalYards;

					//Construct Jobs
					const newJobs = jobs.map((job) => {
						const totalCogs = getAggregateCogsCost(job.aggregate);

						const qbPrice = job.qbPrice || 0;

						return {
							key: job._id,
							_id: job._id,
							psiId: job.psiId,
							loadYD3: job.loadYD3,
							targetYD3: job.targetYD3,
							unitPrice: job.unitPrice,
							aggregate: job.aggregate,
							plant: job.plant.name,
							psi: job.psiId.psi,
							date: dayjs(job.scheduledDate).format("MM/DD/YYYY"),
							client: job.customer.name,
							jobId: job.number.toString(),
							totalYards: job.loadYD3,
							totalUnitPrice: job.loadYD3 * job.unitPrice || 0,
							totalAverage:
								job.loadYD3 === 0
									? 0
									: (job.loadYD3 * job.unitPrice) / job.loadYD3,
							qbInvoiced: job.loadYD3 * qbPrice || 0,
							cogs: totalCogs,
							qbPrice: qbPrice,
							grossProfit: qbPrice - totalCogs < 0 ? 0 : qbPrice - totalCogs,
							grossProfitJAP:
								job.unitPrice - totalCogs < 0 ? 0 : job.unitPrice - totalCogs,
						};
					});

					const qbInvoicedAvg = newJobs.reduce(
						(accum, r) => accum + r.loadYD3 * r.qbPrice,
						0,
					);

					const qbPriceAvg = totalYards === 0 ? 0 : qbInvoicedAvg / totalYards;

					const grossProfitAvg =
						qbPriceAvg - totalCogsJAP > 0 ? qbPriceAvg - totalCogsJAP : 0;

					let obj = {
						key: psiId,
						index: psiId,
						plant: fistRow.plant.name,
						psi: psiName,
						jobs: newJobs,
						totalYards: totalYards,
						totalUnitPrice: totalUnitPrice,
						totalSoldPriceJAP: totalSoldPriceJAP,
						totalCogsJAP: totalCogsJAP,
						totalGrossProfitJAP: totalSoldPriceJAP - totalCogsJAP,
						qbInvoicedAvg: qbInvoicedAvg,
						qbPriceAvg: qbPriceAvg,
						grossProfitAvg: grossProfitAvg,
						franchise: fistRow.franchise || "57Concrete",
					};
					return obj;
				});

				newRows.sort((a, b) =>
					String(a.psi).localeCompare(String(b.psi), undefined, {
						numeric: true,
						sensitivity: "base",
					}),
				);

				setList(newRows);

				let calculateTotals = {};

				let totalYardsTotal = 0;
				let totalUnitPriceTotal = 0;
				let totalSoldPriceJAPTotal = 0;
				let totalCogsJAPTotal = 0;
				let totalGrossProfitTotal = 0;
				let qbInvoicedAvgTotal = 0;
				let totalqbPriceTotal = 0;
				let totalqbProfitTotal = 0;

				newRows.forEach((item) => {
					totalYardsTotal += item.totalYards;
					totalUnitPriceTotal += item.totalUnitPrice;
					totalCogsJAPTotal += item.totalYards * item.totalCogsJAP;
					totalGrossProfitTotal += item.totalYards * item.totalGrossProfitJAP;
					totalqbProfitTotal += item.totalYards * item.grossProfitAvg;
					qbInvoicedAvgTotal += item.qbInvoicedAvg;
				});

				totalSoldPriceJAPTotal = totalUnitPriceTotal / totalYardsTotal;

				totalCogsJAPTotal = totalCogsJAPTotal / totalYardsTotal;
				totalGrossProfitTotal = totalGrossProfitTotal / totalYardsTotal;
				totalqbPriceTotal = qbInvoicedAvgTotal / totalYardsTotal;
				totalqbProfitTotal = totalqbProfitTotal / totalYardsTotal;

				calculateTotals.totalYardsTotal = totalYardsTotal;
				calculateTotals.totalUnitPriceTotal = totalUnitPriceTotal;
				calculateTotals.totalSoldPriceJAPTotal = totalSoldPriceJAPTotal;
				calculateTotals.totalCogsJAPTotal = totalCogsJAPTotal;
				calculateTotals.totalGrossProfitTotal = totalGrossProfitTotal;
				calculateTotals.qbInvoicedAvgTotal = qbInvoicedAvgTotal;
				calculateTotals.totalqbPriceTotal = totalqbPriceTotal;
				calculateTotals.totalqbProfitTotal = totalqbProfitTotal;

				setTotals(calculateTotals);

				const newRows2 = Object.entries(groupedWaste57).map(([key, jobs]) => {
					const fistRow = jobs[0];
					const [psiId, psiName] = key.split("_");

					const totalYards = jobs.reduce((accum, r) => accum + r.loadYD3, 0);

					const totalCogsJAP = jobs.reduce(
						(accum, r) =>
							accum + r.aggregate ? getAggregateCogsCost(r.aggregate) : 0,
						0,
					);

					//Construct Jobs
					const newJobs = jobs.map((job) => {
						const totalCogs = getAggregateCogsCost(job.aggregate);

						return {
							key: job._id,
							_id: job._id,
							psiId: job.psiId,
							loadYD3: job.loadYD3,
							targetYD3: job.targetYD3,
							unitPrice: job.unitPrice,
							aggregate: job.aggregate,
							plant: job.plant.name,
							psi: job.psiId.psi,
							date: dayjs(job.scheduledDate).format("MM/DD/YYYY"),
							client: job.customer.name,
							jobId: job.number.toString(),
							totalYards: job.loadYD3,
							cogs: totalCogs,
						};
					});

					let obj = {
						key: psiId,
						index: psiId,
						plant: fistRow.plant.name,
						psi: psiName,
						jobs: newJobs,
						totalYards: totalYards,
						totalCogsJAP: totalCogsJAP,
						franchise: fistRow.franchise || "57Concrete",
					};
					return obj;
				});

				newRows2.sort((a, b) =>
					String(a.psi).localeCompare(String(b.psi), undefined, {
						numeric: true,
						sensitivity: "base",
					}),
				);

				setListWaste(newRows2);

				let calculateTotalsWaste = {};

				let totalYardsTotalWaste = 0;
				let totalCogsJAPTotalWaste = 0;

				newRows2.forEach((item) => {
					totalYardsTotalWaste += item.totalYards;
					totalCogsJAPTotalWaste += item.totalYards * item.totalCogsJAP;
				});

				totalCogsJAPTotalWaste = totalCogsJAPTotalWaste / totalYardsTotalWaste;

				calculateTotalsWaste.totalYardsTotal = totalYardsTotalWaste;
				calculateTotalsWaste.totalCogsJAPTotal = totalCogsJAPTotalWaste;

				setTotalsWaste(calculateTotalsWaste);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingData(false);
			setLoadingDataWaste(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const getJobListExtras = async () => {
		setLoadingExtra(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyplant/extras/${plant}/${"All"}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const extraFields = [
					{
						key: "fuel",
						label: "Fuel Surcharge",
						value: "fuelSurcharge",
						global: "fuelSurchargeGlobal",
					},
					{
						key: "time",
						label: "Time Surcharge",
						value: "timeSurcharge",
						global: "timeSurchargeGlobal",
					},
					{
						key: "light",
						label: "Light Surcharge",
						value: "lightSurcharge",
						global: "lightSurchargeGlobal",
					},
					{
						key: "ice",
						label: "Ice Surcharge",
						value: "iceSurcharge",
						global: "iceSurchargeGlobal",
					},
					{
						key: "rental",
						label: "Ready Mix Truck Rental Service",
						value: "readyMixTruckRentalService",
						global: "readyMixTruckRentalServiceGlobal",
					},
					{
						key: "driver",
						label: "Ready Mix Driver",
						value: "readyMixDriver",
						global: "readyMixDriverGlobal",
					},
					{
						key: "standby",
						label: "Plant Stand By",
						value: "plantStandBy",
						global: "plantStandByGlobal",
					},
					{
						key: "environmental",
						label: "Environmental Charge Per Load",
						value: "environmentalChargePerLoad",
						global: "environmentalChargePerLoadGlobal",
					},
					{
						key: "shipping",
						label: "Shipping",
						value: "deliveryFee",
						global: "shippingGlobal",
					},
				];

				let listExtra = [];
				const totals = {};

				data.payload.forEach((job) => {
					extraFields.forEach((extra) => {
						const value = job[extra.value];

						if (!value) return;

						const total = job[extra.global] ? value : value * job.loads;

						listExtra.push({
							key: `${extra.key}-${job._id}`,
							index: `${extra.key}-${job._id}`,
							extraText: extra.label,
							total,
							plant: job.plant.name,
							date: dayjs(job.scheduledDate).format("MM/DD/YYYY"),
							jobId: job.number.toString(),
						});

						totals[extra.label] = (totals[extra.label] || 0) + total;
					});
				});

				listExtra.sort((a, b) => {
					if (a.jobId !== b.jobId) {
						return a.jobId - b.jobId;
					}

					return a.extraText.localeCompare(b.extraText);
				});

				setExtras(listExtra);

				let filteredExtras = [];

				if (extraCharge === "All") {
					filteredExtras = listExtra;
					const grandTotal = Object.values(totals).reduce(
						(sum, value) => sum + value,
						0,
					);

					setExtrasTotals(grandTotal);
				} else {
					filteredExtras = listExtra.filter(
						(extra) => extra.extraText === extraCharge,
					);
					const grandTotal = filteredExtras.reduce(
						(sum, value) => sum + value.total,
						0,
					);

					setExtrasTotals(grandTotal);
				}

				setExtrasData(filteredExtras);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingExtra(false);
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Error while trying to get extra jobs",
			);
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setOptionsPlant(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<RenderTableData />
				<RenderTableDataWaste />
				<RenderTableExtra />
			</Flex>
		);
	};
	const RenderTableData = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Flex align="end">
					<Text>Franchise 57Concrete</Text>
				</Flex>
				<Table
					columns={columns}
					dataSource={list.filter((i) => i.franchise === "57Concrete")}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					onRow={(record) => ({
						style: {
							background: "#7686bbff",
						},
					})}
					summary={summaryParent}
					loading={loadingData}
				/>
			</Flex>
		);
	};
	const RenderTableDataWaste = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Flex align="end">
					<Text>Waste Loads</Text>
				</Flex>
				<Table
					columns={columnsWaste}
					dataSource={listWaste.filter((i) => i.franchise === "57Concrete")}
					expandable={{
						expandedRowRender: expandedRowRenderWaste,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					onRow={(record) => ({
						style: {
							background: "#7686bbff",
						},
					})}
					summary={summaryWaste}
					loading={loadingDataWaste}
				/>
			</Flex>
		);
	};

	const onChangeExtraCharge = (value) => {
		setExtraCharge(value);

		let filteredExtras = [];

		if (value === "All") {
			filteredExtras = extras;
		} else {
			filteredExtras = extras.filter((extra) => extra.extraText === value);
		}

		setExtrasData(filteredExtras);

		const grandTotal = filteredExtras.reduce(
			(sum, value) => sum + value.total,
			0,
		);

		setExtrasTotals(grandTotal);
	};

	const RenderTableExtra = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Flex align="end" gap={24}>
					<Text>Extra Charges & Fees:</Text>
					<Statistic
						title=""
						value={extrasTotals}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Flex>
				<div>
					<Text>Extra Charge</Text>
					<br />
					<Select
						showSearch
						placeholder="Extra Charge"
						optionFilterProp="children"
						size="large"
						onChange={onChangeExtraCharge}
						filterOption={filterOption}
						options={extraChargeOptions}
						disabled={loadingExtra || !plant}
						value={extraCharge}
						style={{ width: 250 }}
						allowClear={false}
					/>
				</div>
				<Table
					columns={columns3}
					dataSource={extrasData}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "50%",
					}}
					summary={summaryExtras}
					loading={loadingExtra}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangePlantPicker = (value) => {
		setPlant(value.value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderDates = () => {
		return (
			<Flex justify="space-between" align="flex-start">
				<Flex vertical gap={16}>
					<Flex gap={16}>
						<div>
							<Text>Dates</Text>
							<br />
							<RangePicker
								defaultValue={[
									dayjs(startDate, "MM/DD/YYYY"),
									dayjs(endDate, "MM/DD/YYYY"),
								]}
								onChange={onRangeChange}
								format="MM/DD/YYYY"
								size="large"
								disabled={loading}
								allowClear={false}
							/>
						</div>

						<div>
							<Text>Plant</Text>
							<br />
							<Select
								showSearch
								placeholder="Select plant"
								optionFilterProp="children"
								size="large"
								onChange={onChangePlantPicker}
								filterOption={filterOption}
								options={optionsPlant}
								disabled={loading}
								value={plant}
								style={{ width: 250 }}
								allowClear={false}
								labelInValue
							/>
						</div>
					</Flex>

					<Button
						type="primary"
						onClick={handleExportXlsx}
						loading={loading}
						disabled={list.length === 0}
					>
						Download Report
					</Button>
				</Flex>
			</Flex>
		);
	};

	function getFlattenedHeaders(columns, parent = "") {
		return columns.flatMap((col) => {
			const title = col.title;
			if (col.children) {
				return getFlattenedHeaders(col.children, title);
			}
			return title;
		});
	}

	function getFlattenedKeys(columns, parent = "") {
		return columns.flatMap((col) => {
			if (col.children) {
				return getFlattenedKeys(col.children, parent); // skip grouping name
			}
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const isNumber = (v) => typeof v === "number" && Number.isFinite(v);

	const buildBody = (list, franchise) => {
		let data = [];

		if (list.length === 0) {
			return data;
		}

		const headers = getFlattenedHeaders(columns2);
		const keys = getFlattenedKeys(columns2);

		//MAIN DATA
		data.push(["PROFITABILITY REPORT DETAIL"]);
		data.push(["PROFITABILITY REPORT SUMMARY"]);
		data.push([]);
		data.push(["Lower", "Upper"]);
		const start = `${
			startDate.month() + 1
		}/${startDate.date()}/${startDate.year()}`;
		const end = `${endDate.month() + 1}/${endDate.date()}/${endDate.year()}`;
		data.push([start, end]);
		data.push([]);
		data.push(["Plant", list[0].plant, "", "Franchise", franchise]);
		data.push([]);

		//MAIN HEADER
		list.map((itemList) => {
			//SUB HEADER
			data.push(headers);
			//EACH LINE
			const childrenList = itemList.jobs;
			childrenList.map((children) => {
				let newRow = [];
				keys.forEach((key) => {
					newRow.push(
						isNumber(children[key])
							? children[key].toFixed(2)
							: (children[key] ?? ""),
					);
				});
				data.push(newRow);
			});

			data.push([]);

			let subtotal = ["", "", "", "", "Subtotal"];

			subtotal.push(itemList["totalYards"].toFixed(2));
			subtotal.push(itemList["totalUnitPrice"].toFixed(2));
			subtotal.push(itemList["totalSoldPriceJAP"].toFixed(2));
			subtotal.push(itemList["totalCogsJAP"].toFixed(2));
			subtotal.push(itemList["totalGrossProfitJAP"].toFixed(2));
			subtotal.push(itemList["qbInvoicedAvg"].toFixed(2));
			subtotal.push(itemList["totalCogsJAP"].toFixed(2));
			subtotal.push(itemList["qbPriceAvg"].toFixed(2));
			subtotal.push(itemList["grossProfitAvg"].toFixed(2));

			data.push(subtotal);

			data.push([]);
		});

		//TOTAL
		let total = ["", "", "", "", "Total"];
		total.push(totals["totalYardsTotal"].toFixed(2));
		total.push(totals["totalUnitPriceTotal"].toFixed(2));
		total.push(totals["totalSoldPriceJAPTotal"].toFixed(2));
		total.push(totals["totalCogsJAPTotal"].toFixed(2));
		total.push(totals["totalGrossProfitTotal"].toFixed(2));
		total.push(totals["qbInvoicedAvgTotal"].toFixed(2));
		total.push(totals["totalCogsJAPTotal"].toFixed(2));
		total.push(totals["totalqbPriceTotal"].toFixed(2));
		total.push(totals["totalqbProfitTotal"].toFixed(2));

		data.push(total);

		data.push([]);
		data.push([]);

		if (listWaste.length > 0) {
			const headers = getFlattenedHeaders(columns2Waste);
			const keys = getFlattenedKeys(columns2Waste);

			data.push([]);
			data.push(["WASTE LOADS"]);
			data.push([]);

			listWaste.map((itemList) => {
				//SUB HEADER
				data.push(headers);
				//EACH LINE
				const childrenList = itemList.jobs;
				childrenList.map((children) => {
					let newRow = [];
					keys.forEach((key) => {
						newRow.push(
							isNumber(children[key])
								? children[key].toFixed(2)
								: (children[key] ?? ""),
						);
					});
					data.push(newRow);
				});

				data.push([]);

				let subtotal = ["", "", "", "", "Subtotal"];

				subtotal.push(itemList["totalYards"].toFixed(2));
				subtotal.push(itemList["totalCogsJAP"].toFixed(2));

				data.push(subtotal);

				data.push([]);
			});

			let total = ["", "", "", "", "Total"];
			total.push(totalsWaste["totalYardsTotal"].toFixed(2));
			total.push(totalsWaste["totalCogsJAPTotal"].toFixed(2));

			data.push(total);

			data.push([]);
			data.push([]);
		}

		//Extras
		data.push(["EXTRA CHARGES & FEES"]);
		data.push([`Extra Charge: ${extraCharge}`]);
		data.push([]);

		data.push(["Job ID", "Plant", "Date", "Extra Charges & Fees", "Total"]);
		extrasData.map((item) => {
			data.push([
				item["jobId"],
				item["plant"],
				item["date"],
				item["extraText"],
				item["total"],
			]);
		});

		data.push([]);

		data.push(["", "", "", "Total", extrasTotals]);

		return data;
	};

	const handleExportXlsx = () => {
		const data = buildBody(
			list.filter((i) => i.franchise === "57Concrete"),
			"57Concrete",
		);

		const ws = XLSX.utils.aoa_to_sheet(data);

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, list[0].plant);

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Profitability Report.xlsx`);
	};

	return (
		<Layout title="Profitability Report" description="Report" type="large">
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderTable />
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default ProfitabilityReport2;
